import LargerHeaderWithNavLayout from '../../layouts/large-header-with-nav-layout';
import { StepBody } from '../../components/step-body';
import { BankStatementsContent } from './bank-statements-content';
import { useFetchStateDataIfNull, useQuery } from '../../util/hooks';

export const BankStatementsPage = () => {
  const query = useQuery();

  const queryParamCheckoutId = query.get('checkoutId');
  useFetchStateDataIfNull(queryParamCheckoutId);

  return (
    <LargerHeaderWithNavLayout>
      <StepBody>
        <BankStatementsContent />
      </StepBody>
    </LargerHeaderWithNavLayout>
  );
};
